const createEvent = (eventName, eventDetail) => {
    return new CustomEvent(eventName, eventDetail);
}

export default createEvent;